export const earnedFromChecklist = {
  Surname: "earnedFromSurnameAdd",
  "Profile pic": "earnedFromAvatarUpdate",
  Email: "earnedFromEmailAdd",
  Address: "earnedFromAddressUpdate",
  "Update first name": "earnedFromNameUpdate",
  Hobbies: "earnedFromHobbiesAdd",
  DOB: "earnedFromDobAdd",
  Profession: "earnedFromProfessionAdd",
  "Super Skill": "earnedFromSuperSkillAdd",
};



// WEBPACK FOOTER //
// ./src/components/UserTokenLedgerModal/constants.js